module.exports = __webpack_public_path__ + "img/Bannieres-campagnes-instagram-2021-03.15152ec1.jpg";